import * as ng from 'angular';
import { SessionService } from './shared';

ng.module('e360')
   .factory('authInterceptor', authInterceptorFactory);

authInterceptorFactory.$inject = ['$q'];
export function authInterceptorFactory($q:ng.IQService,) {
   // attempting to use DI for SessionService causes circular dependency error

   return {
      request: request,
      responseError: responseError
   };

   function request(config: ng.IRequestConfig): ng.IRequestConfig {
      let token = SessionService.instance.getToken();
      if (!token) {
         return config;
      }
      if (!config || config == undefined || !config.url || config.url == undefined || config.url.length < 1 || !ng.isString(config.url)) {
         return config;
      }

      // QR and media site template requests will give CORS error
      // with the Authorization header, use '//' to be more explicit
      // about what requests to add head to
      let configUrl = config.url.toLowerCase();
      const url = new URL(window.location.href);
      let urlHost = url.host.toLowerCase();

      if (ng.isString(configUrl) && configUrl.indexOf('//' + urlHost) > -1) {
         config.headers['Authorization'] = 'Bearer ' + token;
      }

      return config;
   }

   function responseError(rejection: ng.IHttpPromiseCallbackArg<any>): any {
      if (rejection.status == 401) {
         SessionService.instance.logout(true);
      }

      return $q.reject(rejection);
   }
}
